import React from 'react';
import styled from 'styled-components';
import Modal from '../Modal';
import Button from '../Button';
import { $t } from 'src/utils';
import { ReactComponent as PhoneSvg } from 'src/iconic/phone.svg';

export const DECISELY_PHONE = '833-313-7170';

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  h3 {
    margin: 0 auto 12px;
  }

  p {
    margin: 0 0 16px;
  }
`;

const Actions = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  align-items: center;
  width: 100%;
  margin-top: 24px;
`;

const SPhoneSvg = styled(PhoneSvg)`
  height: 20px;
  width: 20px;
  margin-right: 8px;
`;

interface DeciselyCallModalProps {
  open: boolean;
  onClose: () => void;
  planName?: string;
  planId?: string;
}

/**
 * Decisely members enroll by phone, so after choosing a plan they're told to call us
 * instead of being sent to sign up. Copy mirrors the app's state-app hiccup page.
 */
export function DeciselyCallModal({ open, onClose, planName, planId }: DeciselyCallModalProps) {
  return (
    <Modal size="md" open={open} onClose={onClose}>
      <Body>
        <h3>{$t({ id: 'explorer/decisely-call.title', defaultMessage: 'Call us to apply' })}</h3>
        <p>
          {$t({
            id: 'explorer/decisely-call.subtitle',
            defaultMessage:
              'Our team is here to help you with your application at {phone}. Your application is not finished yet, you must call us to continue!',
            data: { phone: DECISELY_PHONE },
          })}
        </p>
        {planName && (
          <p>
            <strong>
              {$t({
                id: 'explorer/decisely-call.selected-plan',
                defaultMessage: 'Your selected plan:',
              })}
            </strong>{' '}
            {planName}
            {planId && ` (${planId})`}
          </p>
        )}
        <Actions>
          <Button color="var(--c-bg-inset)" textColor="var(--c-fg-0)" onPress={onClose}>
            {$t({ id: 'explorer/decisely-call.later', defaultMessage: 'Maybe later' })}
          </Button>
          <Button
            onPress={() => {
              window.location.href = `tel:${DECISELY_PHONE.replace(/\D/g, '')}`;
            }}
          >
            <SPhoneSvg aria-hidden />
            {$t({
              id: 'explorer/decisely-call.call',
              defaultMessage: 'Call {phone}',
              data: { phone: DECISELY_PHONE },
            })}
          </Button>
        </Actions>
      </Body>
    </Modal>
  );
}
